import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/courses.css";
import BackgroundSection1 from "../assets/images/Photo1section3hmpg.png";

const Coursespage = ({ setLocation, classDetails }) => {
  const navigate = useNavigate();

  const address = useLocation();

  const handleNavigate = (goto) => {
    navigate(goto);
  };

  useEffect(() => {
    setLocation(address);
  }, []);
  return (
    <main>
      <div className="custom-con1-courses position-relative">
        <img
          src={BackgroundSection1}
          alt="background.png"
          className="adjust-img-section1-courses object-fit-cover"
        />
        <div className="custom-con-text-section1-courses position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center flex-column">
          <p className="custom-text-number-section1-courses">10</p>
          <p className="custom-text-section1-courses">
            Thoughtful courses that will guide you in this journey.
          </p>
          <button
            className="custom-btn-section1-courses"
            onClick={() => handleNavigate("/programs")}
          >
            Register Now
          </button>
        </div>
      </div>
      <div className="custom-con2-courses d-flex justify-content-center align-items-center">
        <div className="custom-con-width-section4-hmpg">
          <p className="custom-title-section4-hmpg text-center">Our Subjects</p>
          <div className="row align-items-center justify-content-center custom-row-section4-hmpg">
            {classDetails.map((item, index) => (
              <div
                className="col-12 col-md-4 col-lg-4 col-xl-4l col-xxl-4 d-flex align-items-center justify-content-center p-0"
                key={index}
              >
                <div className="custom-con-content-column-section4-hmpg d-flex justify-content-center flex-column p-4">
                  <p className="custom-title-card-section4-hmpg">
                    {item.className}
                  </p>
                  <p className="custom-text-card-section4-hmpg">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Coursespage;
